import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState, Fragment } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../Scanit.module.css';
import PercentTip from '../../../components/PercentTip/PercentTip';

//TODO: Ejemplo de como debe quedar un hook
const TotalScanits = (props) => {
	const { isLoading, scanitData, title, info } = props;

	const [booleanMayor, setBooleanMayor] = useState(false);
	const [percentChange, setPercentChange] = useState('');
	const [monthYear, setMonthYear] = useState('');
	const [monthYearInitial, setMonthYearInitial] = useState('');

	const formatDate = (dateToTransform) => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		const updateHook = async () => {
			if (isLoading === false) {
				setPercentChange(scanitData.percentChangeScanits);
				setMonthYear(formatDate(scanitData.initialDate));
				setMonthYearInitial(formatDate(scanitData.compareDate));
			}
		};
		updateHook();
	}, [isLoading, scanitData]);

	useEffect(() => {
		const updatePercent = async () => {
			if (isLoading === false && percentChange !== 0) {
				if (percentChange < 0) {
					setBooleanMayor(true);
				} else {
					setBooleanMayor(false);
				}
			}
		};
		updatePercent();
	}, [percentChange, isLoading]);

	return (
		<React.Fragment>
			<div className={classes.headerTitle}>
				{title} <br />
				{info}
			</div>

			<div className={classes.date}>{monthYear}</div>
			{isLoading ? (
				<CircularProgress />
			) : (
				<div>
					<div className={classes.number}>
						<NumberFormat value={scanitData.nScanitsActual} displayType={'text'} thousandSeparator={true} decimalScale={0} />
					</div>

					{booleanMayor ? (
						<FontAwesomeIcon className={classes.faArrowDown} icon={faArrowDown} />
					) : (
						<FontAwesomeIcon className={classes.faArrowUp} icon={faArrowUp} />
					)}

					<br></br>
					<div className={classes.percent}>
						<Fragment>
							<div className={classes.percent}>
								<PercentTip
									value={<NumberFormat value={percentChange} displayType={'text'} decimalScale={2} suffix={'%'} />}
									percentChange={percentChange}
									text={
										<Fragment>
											<div>Comparación con {monthYearInitial}</div>
											<br></br>
											<div>
												<NumberFormat value={scanitData.nReportesAnterior} displayType={'text'} thousandSeparator={true} />
											</div>
										</Fragment>
									}
								/>
							</div>
						</Fragment>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default React.memo(TotalScanits);
